.numericRange {
  display: flex;
  align-items: center;
  gap: var(--bc-margin-xs, 8px);
}

.numericRangeDash {
  color: var(--bc-color-text-placeholder, #6F8CAE);
}
